import useDropdownMenu from "react-accessible-dropdown-menu-hook";
import { FaArrowRightFromBracket, FaCalendarDays } from "react-icons/fa6";
import { getUserAvatarUrl, hasPermission, isLogged } from "../Utils";
import { useUser } from "../UserProvider";

export const LoggedInfo = () => {
  const userProvider = useUser();
  
  const { user, loading } = userProvider;

  const menuItems = hasPermission(user, 3) ? 4 : (hasPermission(user, 2) ? 3 : 2);
  const { buttonProps, itemProps, isOpen } = useDropdownMenu(menuItems);
  

  // Tant que l'utilisateur n'est pas chargé, on ne fait rien (ou un loading state si tu veux)
  if (loading) {
    return (
      <span className="text-3xl flex navItem transi-all select-none text-gray-600 dark:text-gray-400">
        Loading...
      </span>
    );
  }

  if (!isLogged() || !user) {
    return (
      <span className="text-3xl flex navItem transi-all select-none text-gray-600 dark:text-gray-400">
        Logged
      </span>
    );
  }



  const username = user?.username;


  let currentProps = 0;
  function getItemProps() {
    return itemProps[currentProps++];
  }

  return (
    <div className="relative inline-block text-left">
      <button
        {...buttonProps}
        className={`navItem flex items-center text-2xl rounded-full md:rounded-lg px-1 py-1 md:px-3 bg-white dark:bg-gray-800 shadow-sm border border-gray-300 dark:border-gray-700 hover:bg-green-50 dark:hover:bg-green-900 transition focus:outline-none focus:ring-2 focus:ring-green-500`}
      >
        <img
          src={getUserAvatarUrl(user)}
          alt={username}
          className="rounded-full w-10 h-10 md:mr-3 object-cover"
        />
        <span className="select-none text-gray-900 dark:text-gray-100 hidden md:block">{username}</span>
      </button>

      {/* Dropdown menu */}
      <div
        className={`${isOpen ? "" : "hidden"
          } absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white dark:bg-gray-900 ring-1 ring-black ring-opacity-5 transition-all z-50`}
        style={{ bottom: "calc(-55px * " + menuItems + " - " + 10 * (menuItems - 1) + "px)" }}
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="menu-button"
      >
        <div className="py-1">
           <a
            {...getItemProps()}
            href="/contests"
            className="w-full text-left flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-green-600 hover:text-white transition cursor-pointer"
            role="menuitem"
            tabIndex={-1}
          >
            <FaCalendarDays className="mr-3 w-12 text-3xl" />
            Contests
          </a>
          {hasPermission(user, 2) && (
            <a
              {...getItemProps()}
              href="/uploadChests"
              className="flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-green-600 hover:text-white transition cursor-pointer"
              role="menuitem"
              tabIndex={-1}
            >
              <img
                src={process.env.REACT_APP_API_URL + "/image/nec.gif"}
                alt=""
                className="mr-3 w-12 rounded-sm object-contain"
              />
              Upload Chest Textures
            </a>
          )}
          {hasPermission(user, 3) && (
            <a
              {...getItemProps()}
              href="/adminPanel"
              className="flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-green-600 hover:text-white transition cursor-pointer"
              role="menuitem"
              tabIndex={-1}
            >
              <img
                src="https://miro.medium.com/v2/resize:fit:1400/1*5Hnnv0awfSv0BGcq1C522w.png"
                alt=""
                className="mr-3 w-12 rounded-sm object-contain"
              />
              Admin Panel
            </a>
          )}

          <a
            {...getItemProps()}
            href="/logout"
            className="w-full text-left flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-green-600 hover:text-white transition cursor-pointer"
            role="menuitem"
            tabIndex={-1}
          >
            <FaArrowRightFromBracket className="mr-3 rotate-180 w-12 text-3xl" />
            Logout
          </a>
        </div>
      </div>
    </div>
  );
};
